// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const USER_PROFILE = {
  name: "Jordan Lutz",
  email: "iod-master@islandoverheaddoors.com",
  role: "Lead Developer",
  phone: "+1 (250) 555-0142",
  location: "Victoria, BC",
  joinDate: "2024-06-15",
  timezone: "Pacific Time (PT)",
  department: "Engineering"
};

const ACTIVITY_LOG = [
  { id:1, action:"Logged in", device:"Chrome / Windows", ip:"192.168.1.xxx", time:"Today, 8:15 AM" },
  { id:2, action:"Logged in", device:"Mobile App / iOS", ip:"10.0.0.xxx", time:"Yesterday, 7:30 PM" },
  { id:3, action:"Logged in", device:"Chrome / Windows", ip:"192.168.1.xxx", time:"Yesterday, 8:00 AM" },
  { id:4, action:"Password changed", device:"Chrome / Windows", ip:"192.168.1.xxx", time:"Feb 3, 2026" },
  { id:5, action:"Logged in", device:"Chrome / macOS", ip:"172.16.0.xxx", time:"Feb 2, 2026" },
  { id:6, action:"Logged in", device:"Chrome / Windows", ip:"192.168.1.xxx", time:"Feb 1, 2026" }
];

const CONNECTED_APPS = [
  { id:1, name:"Supabase", status:"Connected", lastSync:"2 hours ago", icon:"DB" },
  { id:2, name:"Cloudflare Pages", status:"Connected", lastSync:"1 hour ago", icon:"CF" },
  { id:3, name:"GitHub", status:"Connected", lastSync:"30 min ago", icon:"GH" },
  { id:4, name:"Slack", status:"Disconnected", lastSync:"Never", icon:"SL" },
  { id:5, name:"Google Workspace", status:"Connected", lastSync:"1 hour ago", icon:"GW" }
];

export default function ProfilePage() {
  const [profile] = useState(USER_PROFILE);
  const [notifications, setNotifications] = useState({
    email: true,
    push: true,
    taskAssigned: true,
    taskCompleted: true,
    mentions: true,
    weeklyReport: true,
    dealUpdates: false,
    systemAlerts: true
  });
  const [theme, setTheme] = useState("dark");
  const [twoFactor, setTwoFactor] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState(false);

  const toggleNotification = (key) => {
    setNotifications(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const initials = profile.name.split(" ").map(n => n[0]).join("");

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Profile</h1><p>Manage your account settings</p></div>
      </div>

      <div className="grid-2">
        {/* Profile Card */}
        <div className="card">
          <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:20}}>
            <div style={{width:64,height:64,borderRadius:"50%",background:"linear-gradient(135deg, #10b981, #3b82f6)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,fontWeight:700,color:"white"}}>{initials}</div>
            <div>
              <div style={{fontSize:18,fontWeight:700,color:"#e2e8f0"}}>{profile.name}</div>
              <div style={{fontSize:13,color:"#10b981"}}>{profile.role}</div>
              <div style={{fontSize:12,color:"#64748b"}}>{profile.department}</div>
            </div>
          </div>

          <div style={{display:"grid",gap:12}}>
            {[
              { label:"Email", value:profile.email },
              { label:"Phone", value:profile.phone },
              { label:"Location", value:profile.location },
              { label:"Timezone", value:profile.timezone },
              { label:"Joined", value:profile.joinDate }
            ].map(f => (
              <div key={f.label} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #334155"}}>
                <span style={{fontSize:13,color:"#94a3b8"}}>{f.label}</span>
                <span style={{fontSize:13,color:"#e2e8f0",fontWeight:500}}>{f.value}</span>
              </div>
            ))}
          </div>

          <button className="btn btn-outline" style={{marginTop:16,width:"100%"}}>Edit Profile</button>
        </div>

        {/* Security */}
        <div>
          <div className="card">
            <div className="card-header"><h3>Security</h3></div>

            <div style={{padding:"12px 0",borderBottom:"1px solid #334155"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{fontSize:14,fontWeight:600,color:"#e2e8f0"}}>Password</div>
                  <div style={{fontSize:12,color:"#64748b"}}>Last changed: Feb 3, 2026</div>
                </div>
                <button className="btn btn-sm btn-outline" onClick={() => setShowPasswordForm(!showPasswordForm)}>Change</button>
              </div>
              {showPasswordForm && (
                <div style={{marginTop:12,display:"grid",gap:8}}>
                  <div><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>Current Password</label><input className="input" type="password" placeholder="Enter current password" /></div>
                  <div><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>New Password</label><input className="input" type="password" placeholder="Enter new password" /></div>
                  <div><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>Confirm New Password</label><input className="input" type="password" placeholder="Confirm new password" /></div>
                  <div style={{display:"flex",gap:8}}><button className="btn btn-primary btn-sm">Update Password</button><button className="btn btn-outline btn-sm" onClick={() => setShowPasswordForm(false)}>Cancel</button></div>
                </div>
              )}
            </div>

            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0",borderBottom:"1px solid #334155"}}>
              <div>
                <div style={{fontSize:14,fontWeight:600,color:"#e2e8f0"}}>Two-Factor Authentication</div>
                <div style={{fontSize:12,color:"#64748b"}}>{twoFactor ? "Enabled - using authenticator app" : "Not enabled"}</div>
              </div>
              <button className={"btn btn-sm "+(twoFactor?"btn-outline":"btn-primary")} onClick={() => setTwoFactor(!twoFactor)}>
                {twoFactor ? "Disable" : "Enable"}
              </button>
            </div>

            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0"}}>
              <div>
                <div style={{fontSize:14,fontWeight:600,color:"#e2e8f0"}}>Active Sessions</div>
                <div style={{fontSize:12,color:"#64748b"}}>2 devices currently signed in</div>
              </div>
              <button className="btn btn-sm btn-outline">Manage</button>
            </div>
          </div>

          {/* Theme Preference */}
          <div className="card">
            <div className="card-header"><h3>Appearance</h3></div>
            <div style={{display:"flex",gap:12}}>
              <div style={{flex:1,padding:16,borderRadius:8,border:theme==="dark"?"2px solid #10b981":"2px solid #334155",background:"#0f172a",cursor:"pointer",textAlign:"center"}} onClick={() => setTheme("dark")}>
                <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>Dark</div>
                <div style={{fontSize:11,color:"#64748b"}}>Default theme</div>
              </div>
              <div style={{flex:1,padding:16,borderRadius:8,border:theme==="light"?"2px solid #10b981":"2px solid #334155",background:"#334155",cursor:"pointer",textAlign:"center"}} onClick={() => setTheme("light")}>
                <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>Light</div>
                <div style={{fontSize:11,color:"#64748b"}}>Coming soon</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notification Preferences */}
      <div className="card" style={{marginTop:16}}>
        <div className="card-header"><h3>Notification Preferences</h3></div>
        <div className="grid-2">
          {[
            { key:"email", label:"Email Notifications", desc:"Receive updates via email" },
            { key:"push", label:"Push Notifications", desc:"Browser push notifications" },
            { key:"taskAssigned", label:"Task Assigned", desc:"When a task is assigned to you" },
            { key:"taskCompleted", label:"Task Completed", desc:"When your tasks are marked done" },
            { key:"mentions", label:"Mentions", desc:"When someone mentions you" },
            { key:"weeklyReport", label:"Weekly Report", desc:"Automated weekly summary" },
            { key:"dealUpdates", label:"Deal Updates", desc:"When deal status changes" },
            { key:"systemAlerts", label:"System Alerts", desc:"Platform status and alerts" }
          ].map(n => (
            <div key={n.key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:"1px solid #334155"}}>
              <div>
                <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{n.label}</div>
                <div style={{fontSize:11,color:"#64748b"}}>{n.desc}</div>
              </div>
              <div style={{width:44,height:24,borderRadius:12,background:notifications[n.key]?"#10b981":"#334155",cursor:"pointer",position:"relative",transition:"background 0.2s"}} onClick={() => toggleNotification(n.key)}>
                <div style={{width:18,height:18,borderRadius:9,background:"white",position:"absolute",top:3,left:notifications[n.key]?23:3,transition:"left 0.2s"}} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Connected Apps */}
      <div className="card" style={{marginTop:16}}>
        <div className="card-header"><h3>Connected Apps</h3></div>
        {CONNECTED_APPS.map(app => (
          <div key={app.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0",borderBottom:"1px solid #334155"}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:36,height:36,borderRadius:8,background:"#1e293b",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:"#94a3b8"}}>{app.icon}</div>
              <div>
                <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{app.name}</div>
                <div style={{fontSize:11,color:"#64748b"}}>Last sync: {app.lastSync}</div>
              </div>
            </div>
            <span className={app.status==="Connected"?"badge badge-green":"badge badge-red"}>{app.status}</span>
          </div>
        ))}
      </div>

      {/* Activity Log */}
      <div className="card" style={{marginTop:16}}>
        <div className="card-header"><h3>Activity Log</h3></div>
        {ACTIVITY_LOG.map(a => (
          <div key={a.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:"1px solid #334155"}}>
            <div>
              <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{a.action}</div>
              <div style={{fontSize:11,color:"#64748b"}}>{a.device} | IP: {a.ip}</div>
            </div>
            <span style={{fontSize:12,color:"#94a3b8"}}>{a.time}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
